<template>
  <div class="dialog-mask" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header">{{prod.TitleProduct}}</div>
      <div class="dialog-body">
        <ul class="nav" :key="prod.Id + 'nav'">
          <li class="space-between"><!--<span>{{ 'Network' | lang }}</span>--><span>{{ prod.TitleNetwork }}</span></li>
          <li class="space-between" v-if="prod.RenewalDetail"><span>{{ prod.RenewalDetail }}</span></li>
          <li class="space-between"><span>{{ prod.Title }}</span></li>
          <li class="space-between"><span>{{ prod.TitleProductDetail }}</span></li>
        </ul>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(true)">{{ 'Close' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'ProductInfos',
  mixins: [ dialogMixin ],
  props: ['prod'],
  computed: {},
  data () {
    return {}
  }
}
</script>

<style lang="scss">
// @import '@/assets/_vars.scss';
</style>
